// @ts-nocheck
import MobileSkeleton from '../MobileSkeleton/MobileSkeleton';
import DesktopSkeleton from '../DesktopSkeleton/DesktopSkeleton';

const TravelerAppSkeleton = () => {
  return (
    <div className='traveler-app-skeleton'>
      {/* Desktop Skeleton - Only visible on screens > 1023px */}
      <DesktopSkeleton />

      {/* Mobile Skeleton - Only visible on screens <= 1023px */}
      <MobileSkeleton />
    </div>
  );
};

export default TravelerAppSkeleton;
